export const anchorLinks = () => {
  const anchorLink = ".js-anchor-link";

  const init = () => {
    bind();
  };

  const bind = () => {
    $(anchorLink).on("click", function (e) {
      e.preventDefault();
      const element = $(this).data("href");
      $([document.documentElement, document.body]).animate(
        {
          scrollTop: $("#" + element).offset().top - $(".js-header").height(),
        },
        660
      );
    });
  };

  init();
};
